import type { ReactNode } from "react";
import { SurfaceProvider } from "~/lib/surface-context";
import { ToastProvider } from "~/lib/toast/provider";
import { m } from "~/lib/i18n";

export function MissingPrivyConfig() {
  return (
    <div className="mx-auto mt-8 w-full max-w-2xl rounded-[1.75rem] border border-red-300/70 bg-red-50/90 p-5 text-status-negative-foreground shadow-sm">
      <h1 className="text-body font-semibold">
        {m.components_app_providers_missing_privy_heading({
          environmentVariable: "`VITE_PRIVY_APP_ID`",
        })}
      </h1>
      <p className="mt-2 text-meta">
        {m.components_app_providers_missing_privy_description({
          appName: "`webapp-v2`",
          environmentVariable: "`VITE_PRIVY_APP_ID`",
        })}
      </p>
    </div>
  );
}

function GlobalUiProviders({ children }: { children: ReactNode }) {
  // ToastProvider renders the bottom-center pill stack (execution + simple
  // toasts — v1 parity) and the expanded detail modal.
  return (
    <>
      <SurfaceProvider value={1}>{children}</SurfaceProvider>
      <ToastProvider />
    </>
  );
}

export function AppUiProviders({ children }: { children: ReactNode }) {
  return <GlobalUiProviders>{children}</GlobalUiProviders>;
}
